/* 

Larghezza automatica colonne file xlsx.

La prima funzione serve per xlsx costruito come AOA (Array di Array), la seconda se è costruito con json. Esempio di utilizzo:

const ws = XLSX.utils.aoa_to_sheet(datiFoglio);
ws["!cols"] = autoWidthAOAExcept(datiFoglio, {
    minW: 8,
    maxW: 26,
    excludeCols: [0], // escludi dal calcolo della larghezza la colonna 0
    fixedWidth: { 0: 10 } // larghezza fissa per la prima colonna
});

*/

export function autoWidthAOAExcept(aoa, opts) {
  opts = opts || {};
  const minW = opts.minW || 8;
  const maxW = opts.maxW || 26;
  const excludeCols = new Set(opts.excludeCols || []);
  const fixedWidth = opts.fixedWidth || {}; // es: { 1: 50 }

  // numero colonne = riga più lunga
  let colCount = 0;
  for (let r = 0; r < aoa.length; r++) {
    const row = aoa[r];
    if (row && row.length > colCount) colCount = row.length;
  }

  const widths = Array(colCount).fill(minW);

  for (let c = 0; c < colCount; c++) {
    // colonne escluse: larghezza fissa (se data) oppure minW
    if (excludeCols.has(c)) {
      widths[c] = (fixedWidth[c] !== undefined) ? fixedWidth[c] : minW;
      continue;
    }

    let best = minW;

    for (let r = 0; r < aoa.length; r++) {
      const cell = aoa[r] ? aoa[r][c] : undefined;

      // nel tuo AOA ci sono anche oggetti {v: "...", s: ...}
      let v = cell;
      if (cell && typeof cell === "object" && "v" in cell) v = cell.v;

      if (v === null || v === undefined) continue;

      const s = String(v);
      if (s.length > best) best = s.length;
    }

    if (best < minW) best = minW;
    if (best > maxW) best = maxW;

    widths[c] = best;
  }

  return widths.map(w => ({ wch: w }));
}

export function autoWidthJSONExcept(json, opts) {
  opts = opts || {};
  const minW = opts.minW || 8;
  const maxW = opts.maxW || 40;
  const excludeCols = new Set(opts.excludeCols || []);
  const fixedWidth = opts.fixedWidth || {};
  const dateSample = opts.dateSample || "dd/mm/yyyy"; // usato solo per stimare larghezza

  if (!json || !json.length) return [];

  const headers = opts.headers || Object.keys(json[0]);

  const widths = headers.map((h, idx) => {
    if (excludeCols.has(idx)) {
      return (fixedWidth[idx] !== undefined) ? fixedWidth[idx] : minW;
    }

    let best = Math.max(minW, String(h).length);

    for (let r = 0; r < json.length; r++) {
      const v = json[r] ? json[r][h] : undefined;
      if (v === null || v === undefined) continue;

      let s;

      // Date: non usare String(date) (lunghissimo perché è qualcosa tipo "Wed Jan 15 2026 00:00:00 GMT+0100 (Central European Standard Time)")
      if (v instanceof Date) {
        s = dateSample; // usiamo invece: "dd/mm/yyyy" => larghezza ~10
      } else {
        s = String(v);
      }

      if (s.length > best) best = s.length;
    }

    if (best > maxW) best = maxW;
    return best;
  });

  return widths.map(w => ({ wch: w }));
}

  
